export default "__VITE_ASSET__CKJ$FBPH__"